<template>
  <div class="ai-recommendations-head-border">
      <div class="ai-recommendations-head-left">
        <div class="ai-recommendations-head-left-title">Based on AI recommendations</div>
        <div v-if="storeList && storeList.length>0" class="ai-recommendations-head-left-subtitle">The primary focus of the store type is located in the United States:</div>
        <div v-else class="no-store-list">Based on your brand and positioning, we recommend a variety of stores to meet various needs: a total of 800 establishments.</div>
        <div class="ai-recommendations-head-left-content" v-for="(item,index) in storeList" :key="index">
          <img src="@/assets/img/vilocal/ai-head-tag.png"/><span>{{item.state}}</span><span>{{item.storeType}}</span><span>{{item.storeCount}}</span>store<span v-if="item.storeCount>1">s</span>
        </div>
        <div class="ai-recommendations-head-left-bottom">The following details are from the stores.</div>
      </div>
      <div class="ai-recommendations-head-right">
        <!-- <img src="@/assets/img/vilocal/ai-recommendations-head-img.png"/> -->
      </div>
    </div>
</template>

<script>
import { getAction } from '../../../api/manage'
export default {
  data() {
    return {
      storeList: []
    }
  },
  created() {
    this.getBaseAIRecommendations()
  },
  methods: {
    getBaseAIRecommendations() {
      getAction('/brand/vilocal/api/v0.2/base-ai-recommendations').then(response => {
        if (response.success) {
          if (response.result) {
            this.storeList = response.result
          }
        } else {
          this.$$message.warning(response.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.no-store-list{
  margin-top: 20px;
  line-height: 30px;
}
.ai-recommendations-head-border{
  width: 100%;
  height: 283px;
  background-color: #F4F4F4;
  border-radius: 5px;
  border: 1px solid #E1E1E1;
  display: flex;
  justify-content: space-between;
  .ai-recommendations-head-left{
    width: 45%;
    padding: 30px;
    .ai-recommendations-head-left-title{
      font-size: 24px;
      font-family: Satoshi-Bold !important;
      color: #262B2F;
    }
    .ai-recommendations-head-left-subtitle,.ai-recommendations-head-left-bottom{
      font-size: 14px;
      font-family: Satoshi-Medium !important;
      color: #262B2F;
      margin-top: 10px;
    }
    .ai-recommendations-head-left-content{
      display: flex;
      align-items: center;
      margin-top: 20px;
      span:nth-child(2){
        // width: 6%;
        margin-right: 5px;
      }
      span:nth-child(3){
        // min-width: 200px;
        // width: 30%;
        margin-right: 5px;
      }
      span:nth-child(4){
        // min-width: 30px;
        // width: 5%;
        margin: 0px 5px;
      }
      img{
        height: 16px;
        width: 16px;
        margin-right: 5px;
      }
    }
    .ai-recommendations-head-left-bottom{
      margin-top: 25px;
    }
  }
  .ai-recommendations-head-right{
    height: 283px;
    background-image:  url('../../../assets/img/vilocal/ai-recommendations-head-img.png') ;
    background-size:cover;
    width: 55%;
    max-width: 882px;
    // width: 55%;
    //
    // img{
    //   width: 100%;
    //   height: 100%;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/ai-recommendations/ai-recommendations-head.vue